import {
  EmptyUnit,
  Resident,
  ResidentsListResponse,
} from "types/Resident";

export function parseResidentsListResponse(
  payload: unknown
): ResidentsListResponse {
  if (Array.isArray(payload)) {
    return { residents: payload as Resident[], emptyUnits: [] };
  }
  if (payload && typeof payload === "object") {
    const data = payload as {
      residents?: Resident[];
      emptyUnits?: EmptyUnit[];
    };
    return {
      residents: Array.isArray(data.residents) ? data.residents : [],
      emptyUnits: Array.isArray(data.emptyUnits) ? data.emptyUnits : [],
    };
  }
  return { residents: [], emptyUnits: [] };
}
